module.exports = __webpack_public_path__ + "static/img/2023_9_8_3.02d18cde.02d18cd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_3.02d18cde.png
// module id = v8DG
// module chunks = 0